import { useQuery } from "@tanstack/react-query";
import { axiosInstanceApiNestingale } from "../axios";

const useGetPhotoRealisticViewStatus = (templateId: string | null, shouldStartPolling: boolean) => {
    return useQuery({
        queryKey: ['photoRealisticViewStatus', templateId],
        queryFn: async () => {
            const { data } = await axiosInstanceApiNestingale.get(
                `v1/api/templates/getPhotoRealisticViewStatus/${templateId}`,
                {
                    // headers: {
                    //     'Designer-Id': 'f67dcdb5-7806-4063-ae08-18127a83eddf'
                    // }
                }
            );
            return data;
        },
        enabled: !!templateId && shouldStartPolling,
        refetchInterval: (data: any) => {
            if (data?.photoRealisticViewStatus !== "Initiated" && data?.photoRealisticViewStatus !== 'Processing') {
                return 300000;
            }
            return false;
        },
        // refetchIntervalInBackground: true,
    });
};

export default useGetPhotoRealisticViewStatus;
